import { render, staticRenderFns } from "./PurchasePlanListDetail.vue?vue&type=template&id=9fc84f04&scoped=true"
import script from "./PurchasePlanListDetail.vue?vue&type=script&lang=js"
export * from "./PurchasePlanListDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchasePlanListDetail.vue?vue&type=style&index=0&id=9fc84f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc84f04",
  null
  
)

export default component.exports